import React from "react"
import PropTypes from "prop-types"
import FavoritesTab from "./FavoritesTab/FavoritesTab"
import { SegmentedButtons } from "components-design-system"

// styles
import "./FavoritesPanel.scss"

const FavoritesPanel = ({ setIsOpen, isOpen }) => {
  const [activeTab, setActiveTab] = React.useState("studies")

  return (
    <div className="favorites-panel">
      <div className="fave-tabs-wrap">
        <SegmentedButtons
          options={[
            {
              value: "studies",
              label: "Studies",
            },
            {
              value: "requests",
              label: "Requests",
            },
          ]}
          onChange={(val) => {
            setActiveTab(val)
          }}
        />
      </div>
      <FavoritesTab
        type={activeTab}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </div>
  )
}

FavoritesPanel.propTypes = {
  setIsOpen: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default FavoritesPanel
